module.exports = __webpack_public_path__ + "static/media/container3.ee784088.jpg";